import React, { useState } from 'react'
import { Button } from 'ui/styled'
import useAccumulatorIssueDeleteAttachment from 'apollo/mutations/AccumulatorIssueAttachment/ACCUMULATOR_ISSUE_DELETE_ATTACHMENT'
import useAccumulatorIssueUpdateAttachment from 'apollo/mutations/AccumulatorIssueAttachment/ACCUMULATOR_ISSUE_UPDATE_ATTACHMENT'
import useAccumulatorIssueUploadAttachment from 'apollo/mutations/AccumulatorIssueAttachment/ACCUMULATOR_ISSUE_UPLOAD_ATTACHMENT'
import Attachments from 'pages/Ticket/components/RequestData/components/Attachments'
import NewAttachment from './components/NewAttachment'

const AccumulatorIssueFieldsAttachment = ({ resource, disabled, form }) => {
  const [newAttachment, setNewAttachment] = useState(null)

  const { onAccumulatorIssueAttachmentDelete } =
    useAccumulatorIssueDeleteAttachment()
  const { onAccumulatorIssueAttachmentUpdate } =
    useAccumulatorIssueUpdateAttachment()
  const { onAccumulatorIssueAttachmentUpload } =
    useAccumulatorIssueUploadAttachment()

  const onRemoveAttachment = () => {
    setNewAttachment(false)
    form.setFieldsValue({ attachments: null })
  }

  const attachToForm = async file => {
    if (!resource) return false

    const { isErrorFree } = await onAccumulatorIssueAttachmentUpload({
      id: resource?.id,
      attachment: {
        file,
        title: form.getFieldValue(['attachments', 0, 'title']),
        notes: form.getFieldValue(['attachments', 0, 'notes'])
      }
    })
    if (!isErrorFree) return false
    onRemoveAttachment()
  }

  const onAddAttachment = () => {
    setNewAttachment(true)
  }

  const attachUpdateHandler = async attachments => {
    if (!attachments || !attachments.length) return false

    await onAccumulatorIssueAttachmentUpdate({
      id: attachments[0].id,
      attachment: {
        notes: attachments[0].notes,
        title: attachments[0].title
      }
    })
  }

  const attachRemoveHandler = async id => {
    await onAccumulatorIssueAttachmentDelete({ id })
  }

  return (
    <>
      {resource && (
        <Attachments
          key={resource?.form_attachment?.id}
          attachments={[resource?.form_attachment]}
          updateHandler={attachUpdateHandler}
          removeHandler={attachRemoveHandler}
          disabled={disabled}
        />
      )}

      {newAttachment && (
        <NewAttachment
          key={newAttachment}
          index={0}
          attachHandler={attachToForm}
          onRemoveAttachment={onRemoveAttachment}
          isSingleFile
          disabled={disabled}
        />
      )}

      <Button
        onClick={onAddAttachment}
        disabled={!!newAttachment || resource?.form_attachment || disabled}
        data-test="ticketAddAttachmentBtn"
      >
        Add New Attachment
      </Button>
    </>
  )
}

export default AccumulatorIssueFieldsAttachment
